/* eslint-disable import/prefer-default-export */
/* eslint-disable lines-between-class-members */
export class ErrorCodeConstants {
  static SYSTEM_EXCEPTION = -1 as number;
  static EMPTY_TOKEN_EXCEPTION = 1 as number;
  static MISALDO_BADINPUT_EXCEPTION = 2 as number;
  static PUNTOSTRAVEL_BADINPUT_EXCEPTION = 3 as number;
  static REVISTA_INCORRECT_YEAR_EXCEPTION = 4 as number;
  static USUARIO_NO_TITULAR_EXCEPTION = 5 as number;
  static NO_USER_IN_SESSION_EXCEPTION = 6 as number;
  static EMPTY_LOCALE_EXCEPTION = 7 as number;
  static DISTINCT_USER = 8 as number;
  static AHORROS_BADINPUT_EXCEPTION = 9 as number;
  static COMPRASTICKETS_BADINPUT_EXCEPTION = 10 as number;
  static PUNTOSTRAVEL_BADWS_EXCEPTION = 11 as number;
  static MOVIMIENTOSTRAVEL_BADWS_EXCEPTION = 12 as number;
  static VALES_USUARIO_ACTIVAR_VALE_EXCEPTION = 13 as number;
  static VALES_USUARIO_VALE_NO_ACTIVABLE_EXCEPTION = 14 as number;
  static UPDATE_SUSCRIPCIONES_EXCEPTION = 15 as number;
  static GUARDAR_MISDATOS_TIPODOC_EXCEPTION = 16 as number;
  static GUARDAR_MISDATOS_EXCEPTION = 17 as number;
  static GUARDAR_MISDATOS_TECDOC_EXCEPTION = 47 as number;
  static GET_DATOS_PERSONALES_EXCEPTION = 18 as number;
  static UPDATE_DATOSACCESO_EMAIL_EXCEPTION = 19 as number;
  static UPDATE_DATOSACCESO_PASSWORD_EXCEPTION = 20 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_BADINPUT_EXCEPTION = 21 as number;
  static UPDATE_TICKET_DIGITAL_EXCEPTION = 22 as number;
  static SEND_SMS_DATOSACCESO_NUMERO_EXISTE_EXCEPTION = 23 as number;
  static UPDATE_DIRECCION_EXCEPTION = 24 as number;
  static DELETE_DIRECCION_EXCEPTION = 25 as number;
  static UPDATE_DATOSACCESO_PASSWORD_NO_VALIDA_EXCEPTION = 26 as number;
  static GOOGLE_PLACE_BAD_INPUT = 27 as number;
  static BAJA_SOCIO_EXCEPTION = 28 as number;
  static TARJETAS_BADINPUT_EXCEPTION = 29 as number;
  static TARJETAS_SOLICITUD_ADICIONAL_EXCEPTION = 30 as number;
  static TARJETAS_ORO_BADINPUT_EXCEPTION = 31 as number;
  static TARJETAS_ORO_ERROR_GENERICO_EXCEPTION = 32 as number;
  static TARJETAS_ORO_ERROR_AME_NULL_EXCEPTION = 33 as number;
  static TARJETAS_CLUBORO_ERROR_EXCEPTION = 34 as number;
  static MISDATOS_RRSS_INPUT_EXCEPTION = 35 as number;
  static MISDATOS_RRSS_SINCRO_EXCEPTION = 36 as number;
  static MISDATOS_GET_DATOS_DIR_FACTURACION_BADINPUT_EXCEPTION = 37 as number;
  static MISDATOS_GET_RAZON_SOCIAL_BADINPUT_EXCEPTION = 38 as number;
  static UPDATE_DATOSACCESO_EMAIL_EXISTING_EXCEPTION = 39 as number;
  static TARJETAS_ORO_ALTA_EXCEPTION = 40 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_INCORRECT_PASSWORD_EXCEPTION = 41 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_MAX_TRIES_EXCEPTION = 42 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_EXPIRED_PASSWORD_EXCEPTION = 43 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION = 44 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION = 45 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION = 102 as number;
  static GO_TO_LOGIN_EXCEPTION = 99 as number;
  static GO_TO_RELOGIN_EXCEPTION = 100 as number;
  static AHORROS_EXCEPTION = 46 as number;
  static UPDATE_DATOSACCESO_EMAIL_CORPORATION = 48 as number;
  static SEND_SMS_DATOSACCESO_NUMERO_TEMPORAL_EXISTE_EXCEPTION = 50 as number;
  static UPDATE_DATOSACCESO_CLIENTEV0_DNI_NO_EDITABLE_SAC = 101 as number;
  static UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION = 103 as number;
  static FIDELIO_CUSTOMER_RECORD_BLOCKED_EXCEPTION = 118 as number;
}
